import BI from '@/pracsys-bi/BI.vue'
import {registerRoute} from '@/router'
import {NavigationOption, useContaCommand} from '@/commandbar/commandBar.service'

export const BI_VIEW = {componentName: 'PracsysBI', component: BI, meta: {requiresOrg: true}}

const {registerNavigationCommand} = useContaCommand()
const commandOption: NavigationOption = {
    icon: 'i-ph-head-circuit', label: 'BI', route: BI_VIEW
}
registerRoute(BI_VIEW)
registerNavigationCommand(commandOption)